import { render, staticRenderFns } from "./quote-detail.vue?vue&type=template&id=39fc3c12&scoped=true"
import script from "./quote-detail.vue?vue&type=script&lang=js"
export * from "./quote-detail.vue?vue&type=script&lang=js"
import style0 from "./quote-detail.vue?vue&type=style&index=0&id=39fc3c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc3c12",
  null
  
)

export default component.exports